import React from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Badge,
  Wrap,
  WrapItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Card from "components/card/Card.js";
import { GOLD_TEXT, GOLD_LIGHT } from "constants/brandColors";

// `stats` is /reports/broadcast's data: { overall: {status:count},
// byTarget: [{targetId, name, platform, isActive, counts:{status:count}}] }.
// Dispatch status is a free-form string column, so both the overall summary
// and the per-target breakdown render as dynamic badges instead of fixed
// columns.
export default function BroadcastStatsPanel({ stats }) {
  const { t } = useTranslation();
  const tableHeaderBg = useColorModeValue("gray.50", "gray.700");
  const tableHeaderColor = useColorModeValue("gray.600", "gray.200");
  const overallEntries = Object.entries(stats?.overall || {});
  const byTarget = stats?.byTarget || [];

  return (
    <Card w="100%" p="20px">
      <Text color={GOLD_TEXT} fontSize="xl" fontWeight="700" mb="14px">
        {t("Broadcast Overview")}
      </Text>

      {overallEntries.length > 0 && (
        <Wrap mb={4}>
          {overallEntries.map(([status, count]) => (
            <WrapItem key={status}>
              <Badge px={2} py={1} borderRadius="md" bg={GOLD_LIGHT} color={GOLD_TEXT}>
                {status}: {count}
              </Badge>
            </WrapItem>
          ))}
        </Wrap>
      )}

      {byTarget.length ? (
        <Box overflowX="auto">
          <Table variant="simple" size="sm">
            <Thead>
              <Tr bg={tableHeaderBg}>
                <Th color={tableHeaderColor}>{t("Target")}</Th>
                <Th color={tableHeaderColor}>{t("Platform")}</Th>
                <Th color={tableHeaderColor}>{t("Active")}</Th>
                <Th color={tableHeaderColor}>{t("Dispatches")}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {byTarget.map((target) => (
                <Tr key={target.targetId}>
                  <Td>{target.name || `#${target.targetId}`}</Td>
                  <Td>{target.platform || "-"}</Td>
                  <Td>
                    <Badge colorScheme={target.isActive ? "green" : "gray"}>
                      {target.isActive ? t("Active") : t("Inactive")}
                    </Badge>
                  </Td>
                  <Td>
                    <Wrap>
                      {Object.entries(target.counts || {}).map(([status, count]) => (
                        <WrapItem key={status}>
                          <Badge fontSize="0.7em" bg={GOLD_LIGHT} color={GOLD_TEXT}>
                            {status}: {count}
                          </Badge>
                        </WrapItem>
                      ))}
                    </Wrap>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      ) : (
        <Text color="gray.500" textAlign="center" py={10}>{t("No data found")}</Text>
      )}
    </Card>
  );
}
